import axios from 'axios';
import { API_SERVER } from '../helpers/constants';
export const doSearch = (data) => axios.get(`${API_SERVER}/search`, { params : data });
